<template>
  <div class="land-container">
  </div>
</template>

<script>
/* eslint-disable */
import { setToken, setMobile, setAccount, setAva, setState  } from '@/utils/auth'

export default {
  data() {
    return {

    }
  },

  methods: {
  },

  created() {
    const { loadData } = this.$route.query

    const dataInfo = JSON.parse(decodeURIComponent(loadData))

    setToken(dataInfo.token)
    setAccount(dataInfo.userName)
    setMobile(dataInfo.mobile)
    setAva(dataInfo.avatar)
    setState(dataInfo.state)

    const query = {}
    if (dataInfo.entrance === 'mInput') {
      query.video_code = dataInfo.video_code,
      query.object_code = dataInfo.object_code,
      query.title = encodeURIComponent(dataInfo.title)
    }

    if (dataInfo.entrance === 'question') {
      query.object_code = dataInfo.object_code,
      query.title = encodeURIComponent(dataInfo.title)
    }

    this.$router.replace({
      name: dataInfo.entrance,
      query
    })
  }
}
</script>

<style lang="scss">

</style>
